import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import {lazyInject, TYPES} from '../../../../../utils/inversify-config';
import MiranaServiceClient from '../../../../../middleware/mirana-client';
import Panel from '../../../../../theme/components/Panel';
import {RouteComponentProps, withRouter} from 'react-router-dom';
import {Store} from 'react-redux';
import {ACCESS_TOKEN} from '../../../../../utils/constants';
import MiranaState from '../../../../../reduxstore/mirana-state';
import {FilePond} from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import fileDownload from 'js-file-download';
import {error} from '../../../../../utils/notification-actions';
import {getFileName} from '../../../../../utils/utils';
import CelularesZonasCargaForm from './celulares-zonas-carga-form'
import * as moment from 'moment';

interface IState {
    error?: string,
    fechaStr?: string
}

class CelularesZonasCarga extends React.Component<RouteComponentProps<any>, IState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    @lazyInject(TYPES.REDUX_STORE)
    public reduxStore: Store<MiranaState>;

    constructor(props) {
        super(props);
        this.state = {};
    }

    private descargarPlantilla = async () => {
        try {
            const response = await this.apiClient.descargarPlantillaCelularesZonas();
            fileDownload(response.data, getFileName(response));
        } catch (ex) {
            this.reduxStore.dispatch(error('Error', 'Error interno al generar plantilla para Celulares Zonas'));
        }
    };

    private handleFechaChange = (fecha: any) => {
        const fechaStr = moment(fecha).format('DD/MM/YYYY');
        this.setState({fechaStr});
    };


    public render() {
        return (
            <Container className='dashboard'>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Celulares: Cargar data</h3>
                    </Col>
                    <Col md={6} lg={6}>
                        <Panel xs={12} md={12} divider={true} title='Cargar data'>
                            <h4 className='subhead' style={{marginBottom: '17px'}}>Descargar plantilla <a
                                onClick={this.descargarPlantilla} href='#'>aquí</a></h4>
                            <Row style={{marginBottom: 10}}>
                                <Col md={6} lg={6}>
                                    <CelularesZonasCargaForm handleFechaChange={this.handleFechaChange}/>
                                </Col>
                            </Row>

                            {this.state.fechaStr ? <FilePond
                                acceptedFileTypes={['.csv']}
                                allowRevert={false}
                                name='files'
                                labelFileProcessingComplete='Carga completada'
                                labelFileProcessing='Subiendo'
                                labelTapToCancel='Presiona para cancelar'
                                labelTapToRetry='Presiona para reintentar'
                                labelFileProcessingError='Error al cargar archivo'
                                onprocessfile={(error) => {
                                    if (!error) {
                                        this.setState({error: undefined})
                                    }
                                }}
                                server={{
                                    url: `${process.env.REACT_APP_API_URL}/api/celulares/territorio?fecha=${this.state.fechaStr}`,
                                    process: {
                                        headers: {
                                            'Authorization': 'Bearer ' + localStorage.getItem(ACCESS_TOKEN)
                                        },
                                        onerror: (error) => {
                                            const errorBody = JSON.parse(error) as any;
                                            if (errorBody.message) {
                                                this.setState({error: errorBody.message})
                                            }
                                        }
                                    }
                                }}

                                fileValidateTypeDetectType={(file) => {
                                    return new Promise((resolve, reject) => {
                                        if (file.name.substr(file.name.length - 4, 4) === '.csv') {
                                            resolve('.csv');
                                        } else {
                                            reject();
                                        }
                                    });
                                }}
                                labelIdle='Suelta tus archivos aquí <span class="filepond--label-action"> Buscar </span>'/> : null
                            }
                        </Panel>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default withRouter(CelularesZonasCarga);


// WEBPACK FOOTER //
// ./src/components/pages/celulares/zonas/carga/celulares-zonas-carga.tsx